import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form/immutable';
import { Button, Icon, Message } from 'semantic-ui-react';

import axios from 'axios';

import allProviders from 'email-providers/all.json';

import _ from 'lodash';
import { compose } from 'recompose';

import { authService } from '../../utils/auth-service';
import withIntercom from '../../hocs/with-guest-intercom';

import TextInput from '../../components/form-input-text';

import { EMAIL_REGULAR_EXPRESSION } from '../../utils/form-input-validation';
import { reportError } from '../../utils/error-handling-service';
import { trackEvent } from '../../utils/metric-analytics-service';
import ThemeSelector from '../../themes/theme-selector';

const TERMS_LINK = ThemeSelector.getTermsAndConditionsLink();

const SCREENING_API = 'https://pzdckebtqf.execute-api.eu-west-1.amazonaws.com/production/signup/user/screen';

class Signup extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  static propTypes = {
    email: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
  };

  static defaultProps = {
    email: null,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      signupError: false,
      modal: false,
      checked: false,
    };

    this.restClient = axios.create({
      timeout: 10000,
      headers: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
  }

  getAuthParams = data => {
    const splitFullname = data.get('fullname').trim().split(/\s+/);

    return {
      connection: 'Username-Password-Authentication',
      responseType: 'token',
      email: data.get('email'),
      password: data.get('password'),
      scope: 'openid app_metadata',
      user_metadata: {
        firstname: splitFullname[0],
        lastname: splitFullname.slice(1, splitFullname.length).join(' '),
        companyname: data.get('companyname'),
      },
    };
  };

  acceptModal = () => {
    this.setState({ modal: false });
    this.googleSignup();
  };

  showModal = () => this.setState({ modal: true });

  hideModal = () => this.setState({ modal: false });

  signUp = suData => {
    const signUpData = {
      name: suData.get('fullname'),
      email: suData.get('email'),
      signupType: 'emailPassword',
      companyname: suData.get('companyname'),
    };
    trackEvent('Sign Up', signUpData);

    this.restClient.post(SCREENING_API, { data: { ...signUpData } })
      .then((response => {
        const { data } = response.data;
        console.log(data);
        if (data.error) {
          reportError('SIGNUP_ERROR', data.error.message);
          this.setState({ signupError: data.error.message });
        } else {
          authService.signup(this.getAuthParams(suData), error => {
            if (error) {
              reportError('SIGNUP_ERROR', error.message);
              this.setState({ signupError: error.message });
            }
          });
        }
      }));
  }

  googleSignupValidate() {
    if (this.props.email) {
      this.showModal();
    } else {
      this.googleSignup();
    }
  }

  googleSignup() {
    const context = this;

    trackEvent('Sign Up', { signupType: 'google' });

    authService.login(
      {
        connection: 'google-oauth2',
        responseType: 'token',
        scope: 'openid app_metadata',
      },
      error => {
        if (error) {
          reportError('GOOGLE_SIGNUP_ERROR', error.message);
          context.setState({ signupError: error.message });
        }
      },
    );
  }

  render() {
    const { handleSubmit, email, invalid } = this.props;
    const { signupError } = this.state;

    const viewportStyles = {
      backgroundColor: '#f7fafa',
      height: 'auto',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '64px 24px',
    };

    const signupBoxStyle = {
      background: 'white',
      border: '1px solid #e8e8e8',
      borderRadius: '4px',
      padding: '24px',
      maxWidth: '960px',
      margin: '0 auto',
    };

    const quoteImageStyle = {
      margin: '10px 16px 0 24px',
    };

    return (
      <div style={viewportStyles}>
        <div className="align-center">
          <img src="/dyzio-logo.png" alt="dyzio" />
          <div className="spacer" />
          <h2>Agencies and brands, sign up for free</h2>
          <p>No credit card required. All features included.</p>
          <div className="spacer large" />
          <div className="flex top" style={signupBoxStyle}>
            <div className="equal align-left">
              {signupError && _.includes(signupError, 'already exist')
                ? <div>
                  <p className="info">It looks like you already have an account with us.</p>
                  <div className="spacer" />
                  <button
                    className="large rose stretch"
                    onClick={() => this.context.router.push('/login')}
                  >
                    <p>Log In</p>
                  </button>
                </div>
                : <form onSubmit={handleSubmit(this.signUp)}>
                  <Field
                    name="fullname"
                    type="text"
                    component={TextInput}
                    img="/icons/user.svg"
                    placeholder="Full name"
                  />
                  <Field
                    name="companyname"
                    type="text"
                    component={TextInput}
                    img="/icons/suitcase.svg"
                    placeholder="Company name"
                  />
                  <Field
                    name="email"
                    type="text"
                    component={TextInput}
                    img="/icons/email.svg"
                    disabled={email}
                    placeholder="Email address"
                  />
                  <Field
                    name="password"
                    type="password"
                    component={TextInput}
                    img="/icons/password.svg"
                    placeholder="Choose a password"
                  />
                  {
                    signupError &&
                    <Message
                      error
                      icon="thumbs down outline"
                      header="Sorry, we can't sign you up automatically"
                      content={signupError}
                    />
                  }
                  <Button
                    type="submit"
                    fluid
                    icon
                    labelPosition="left"
                    color="pink"
                    size="huge"
                    disabled={invalid}
                  >
                    <Icon name="signup" />
                    Sign Up!
                  </Button>
                  <br />
                  <p className="caption align-center">
                      By signing up you agree to our{' '}
                    <a
                      href={TERMS_LINK}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                        terms of service
                    </a>.
                  </p>
                </form>}
            </div>
            <div className="equal">
              <h3>Why you need dyzio!</h3>
              <div className="spacer small" />
              <ul className="align-left">
                <li>
                  <p>Build and manage your own private influencer database</p>
                </li>
                <li>
                  <p>Share influencer shortlists with your clients</p>
                </li>
                <li>
                  <p>Collaborate on influencer campaigns on any social network</p>
                </li>
                <li>
                  <p>Generate and distribute professional daily reports from one place</p>
                </li>
                <li>
                  <p>Identify and understand campaign success metrics</p>
                </li>
              </ul>
              <div className="spacer" />
              <div className="flex top">
                <div className="item">
                  <img style={quoteImageStyle} src="/images/katie.png" alt="Katie Nelson, We Are Delightful" />
                </div>
                <div className="space align-left">
                  <p className="light">“Dyzio has made keeping track of my influencers and selecting the right ones for my campaigns a breeze. And running campaigns has never been easier!”</p>
                  <br />
                  <p><b>Katie Nelson, We Are Delightful</b></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};

  const fullname = values.get('fullname');
  const companyname = values.get('companyname');
  const email = values.get('email');
  const password = values.get('password');

  if (!fullname) errors.fullname = 'Enter your full name.';
  if (!companyname) errors.companyname = 'Enter your company name.';
  if (fullname && fullname.trim().split(/\s+/).length < 2) { errors.fullname = 'Enter both your first and last name.'; }

  if (!email) errors.email = 'Enter your email address.';

  if (email) {
    const isValidEmail = EMAIL_REGULAR_EXPRESSION.test(email);
    if (!isValidEmail) errors.email = 'Enter a valid email address.';
    if (isValidEmail) {
      const emailDomain = _.split(email, '@')[1];
      if (_.includes(allProviders, emailDomain)) {
        errors.email = `We do not allow signups from your email provider [${emailDomain}]. Please use a company email.`;
      }
    }
  }

  if (!password) errors.password = 'Enter a new password.';
  if (password && (password.length < 8 || !password.match(/\d+/g))) {
    errors.password = 'Password must have atleast 8 characters and contain 1 number.';
  }

  return errors;
}

const mapStateToProps = state => ({
  shortId: state.invite.get('shortId'),
  email: state.invite.get('email'),
  initialValues: {
    fullname: state.invite.get('name'),
    email: state.invite.get('email'),
  },
});

export default compose(
  withIntercom,
  connect(mapStateToProps, null),
  reduxForm({
    form: 'SignupForm',
    validate,
  }),
)(Signup);



/** WEBPACK FOOTER **
 ** ./src/containers/company-signup/index.js
 **/